export class Constant {
  static readonly version = '1.1.3'
  static readonly NONE = "None";
  static readonly startImageIndex = 0;
  static readonly width: number = 176;
  static readonly height: number = 176;
  static readonly DEVICE = 'Bip S';
}
